module.exports = __webpack_public_path__ + "img/map.07ff1096.png";